import React from 'react'
import { X } from 'react-feather'
import {
  FormDashboardLabel as Label,
  ButtonOutline
} from '.'
import { useInternationalization } from '../features/i18n'

const ImagePickerSidebar = ({
  defaultValue,
  className,
  label,
  height,
  message,
  buttonWidth,
  returnRaw,
  ratio,
  onChange = () => {}
}) => {
  const fileInput = React.useRef()
  const [image, setImage] = React.useState(undefined)
  const { translate, language } = useInternationalization()

  React.useEffect(() => {
    if(defaultValue){
      setImage(defaultValue)
    }
  }, [defaultValue])

  const handleChange = (e) => {
    console.log(e)
    const file = e.target.files[0]
    if(file){
      const image = URL.createObjectURL(file)

      setImage(image)

      if(typeof onChange === 'function'){
        if(returnRaw){
          onChange(image)
        } else {
          onChange(file)
        }
      }
    }
  }

  const handleRemove = (e) => {
    e.stopPropagation()
    setImage(undefined)

    if(typeof onChange === 'function'){
      onChange(undefined)
    }
  }

  const handleClick = (e) => {
    e.stopPropagation()

    fileInput.current.click()
  }

  return (
    <div className={`${className}`}>
      {
        label &&
        <Label>{label}</Label>
      }
      {
        ratio &&
        <p className="text-sm mb-4">
          {language.name === 'en' ? 'Recommended ratio:' : 'Rasio yang direkomendasikan:'} {ratio}
        </p>
      }
      <div
        className="border border-dashed mb-4 rounded flex justify-center items-center bg-center bg-no-repeat bg-contain cursor-pointer relative"
        onClick={handleClick}
        style={{
          borderColor: '#ddd', height: height ? height : '128px',
          backgroundImage: image ? `url('${image}')` : '',
        }}
      >
        {
          image &&
          <div
            className="h-8 w-8 p-1 bg-white rounded-full text-sm shadow-md flex justify-center items-center absolute top-0 right-0"
            onClick={handleRemove}
          >
            <X />
          </div>
        }
        <input type="file" className="hide hidden" onChange={handleChange} ref={fileInput}/>
        {
          !image &&
          <div className="text-center">
            {
              message &&
              <p className="text-xs text-gray-999 mb-3">{message}</p>
            }
            <ButtonOutline
              onClick={e => e.preventDefault()}
              style={{width: buttonWidth ? buttonWidth : '100%', minWidth: '120px', maxWidth: '160px'}}
            >
              {translate('GENERAL', 'choose_file')}
            </ButtonOutline>
          </div>
        }
      </div>
    </div>
  )
}

export { ImagePickerSidebar }
